// extracted by mini-css-extract-plugin
export default {"walletContainer":"WalletBalance_walletContainer__BO9zS","lineContainer":"WalletBalance_lineContainer__gzbw5","icon":"WalletBalance_icon__nDAu9"};